import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./component/common/Layout";
import HomePage from "./page/Home";
import ContactUsPage from "./page/ContactUs";
import PrivacyPolicyPage from "./page/PrivacyPolicy";
import TermsOfServicePage from "./page/TermsOfService";
import NotFoundPage from "./page/NotFound";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/:lang" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="contact" element={<ContactUsPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="terms-of-service" element={<TermsOfServicePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="/">
          <Route index element={<Navigate to="/en" replace />} />
          <Route
            path="contact"
            element={<Navigate to="/en/contact" replace />}
          />
          <Route
            path="privacy-policy"
            element={<Navigate to="/en/privacy-policy" replace />}
          />
          <Route
            path="terms-of-service"
            element={<Navigate to="/en/terms-of-service" replace />}
          />
          <Route path="*" element={<Navigate to="/en/404" replace />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
